import React from 'react';
import { DatePicker } from 'antd';
import { MonthPickerProps } from 'antd/lib/date-picker';

const ProWeekPicke: React.FC<MonthPickerProps> = React.forwardRef<
  any,
  MonthPickerProps
>((props, ref) => {
  return (
    <DatePicker.MonthPicker ref={ref} {...props} />
  );
});

export default ProWeekPicke;
